import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxCaption3Props extends ITextBoxProps {}

export const TextBoxCaption3 = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Caption3,
  ...rest
}: ITextBoxCaption3Props): JSX.Element => (
  <TextBox title={title} color={color} font={font} {...rest} />
)
